// extracted by mini-css-extract-plugin
module.exports = {"Container":"Forms_Container__1Yspb","Header":"Forms_Header__1zBhc","Collection":"Forms_Collection__3sd79"};